import { composePermissions } from '@/commons/permissoesGrupos';

export default [
    // Lista de Setores
    {
        path: '/administrativo/setores',
        name: 'listaSetores',
        component: () => import('@/modules/administrativo/views/listas/ListaSetoresView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')], isRotaOrigem: true },
    },
    // Árvore de Setores
    {
        path: '/administrativo/setores/arvore',
        name: 'arvoreSetores',
        component: () => import('@/modules/administrativo/views/listas/ArvoreSetoresView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')], isRotaOrigem: true },
    },
    // Cadastro de Setor
    {
        path: '/administrativo/setores/cadastro',
        name: 'cadastroSetor',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroSetorView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },
    // Edição de Setor
    {
        path: '/administrativo/setores/:id/editar',
        name: 'editarSetor',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroSetorView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },
    // Detalhe de Setor
    {
        path: '/administrativo/setores/:id/detalhe',
        name: 'detalheSetor',
        component: () => import('@/modules/administrativo/views/detalhes/SetorViews/DetalheSetorView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')], temFilhas: true },
        props: true,
        redirect: { name: 'detalheSetorVisaoGeral' },
        children: [
            {
                path: 'visao-geral',
                name: 'detalheSetorVisaoGeral',
                component: () => import('@/modules/administrativo/views/detalhes/SetorViews/abas/VisaoGeralSetorTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: 'funcionarios',
                name: 'detalheSetorFuncionarios',
                component: () => import('@/modules/administrativo/views/detalhes/SetorViews/abas/FuncionariosSetorTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: 'solicitacoes',
                name: 'detalheSetorSolicitacoes',
                component: () => import('@/modules/administrativo/views/detalhes/SetorViews/abas/SolicitacoesSetorTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: 'processos',
                name: 'detalheSetorProcessos',
                component: () => import('@/modules/administrativo/views/detalhes/SetorViews/abas/ProcessosSetorTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: 'chefias',
                name: 'detalheSetorChefias',
                component: () => import('@/modules/administrativo/views/detalhes/SetorViews/abas/ChefiaSetorTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: 'orcamento',
                name: 'detalheSetorOrcamento',
                component: () => import('@/modules/administrativo/views/detalhes/SetorViews/abas/OrcamentoSetorTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
        ],
    },
    
    // Lista de Funcionários
    {
        path: '/administrativo/funcionarios',
        name: 'listaFuncionarios',
        component: () => import('@/modules/administrativo/views/listas/ListaFuncionariosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },

    // Lista de Autorizações
    {
        path: '/administrativo/autorizacoes',
        name: 'listaAutorizacoesAdministrativas',
        component: () => import('@/modules/administrativo/views/listas/ListaAutorizacoesView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },
    // Lista de Ordenações (pagamentos das solicitações administrativas), agora uma aba de Ordenações
    {
        path: '/administrativo/ordenacoes',
        name: 'listaOrdenacoesAdministrativas',
        redirect: { name: 'ordenadorSolicitacoesAdministrativas' },
    },

    // Cadastro de Solicitacao Administrativa de Diaria
    {
        path: '/administrativo/setores/:idsetor/solicitacoes/diaria/cadastro',
        name: 'cadastroSolicitacaoAdministrativaDiaria',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroSolicitacaoDiariaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },

    // Edicao de Solicitacao Administrativa de Diaria
    {
        path: '/administrativo/solicitacoes/diaria/:idsolicitacao/editar',
        name: 'editarSolicitacaoAdministrativaDiaria',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroSolicitacaoDiariaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },

    // Cadastro de Solicitacao Administrativa de Auxilio Financeiro
    {
        path: '/administrativo/solicitacoes/auxilio-financeiro/cadastro',
        name: 'cadastroSolicitacaoAdministrativaAuxilioFinanceiro',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroSolicitacaoAuxilioFinanceiroView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },

    // Edicao de Solicitacao Administrativa de Auxilio Financeiro
    {
        path: '/administrativo/solicitacoes/auxilio-financeiro/:idsolicitacao/editar',
        name: 'editarSolicitacaoAdministrativaAuxilioFinanceiro',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroSolicitacaoAuxilioFinanceiroView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },

    // Detalhe de Solicitacao Administrativa
    {
        path: '/administrativo/solicitacoes/:id/detalhe',
        name: 'detalheSolicitacaoAdministrativa',
        component: () => import('@/modules/administrativo/views/detalhes/SolicitacaoAdministrativaViews/DetalheSolicitacaoAdministrativaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },

    // Lista de Processos do Setor
    {
        path: '/administrativo/processos',
        name: 'listaProcessos',
        component: () => import('@/modules/administrativo/views/listas/ListaProcessosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },

    // Lista de Meus Processos
    {
        path: '/administrativo/processos/meus-processos',
        name: 'listaMeusProcessos',
        component: () => import('@/modules/administrativo/views/listas/ListaMeusProcessosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },

    // Lista de Processos Observados
    {
        path: '/administrativo/processos/observados',
        name: 'listaProcessosObservados',
        component: () => import('@/modules/administrativo/views/listas/ListaProcessosInteressadosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },

    // Cadastro de Processo Administrativo
    {
        path: '/administrativo/processos/cadastro',
        name: 'cadastroProcesso',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroProcessoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },

    // Edição de Processo Administrativo
    {
        path: '/administrativo/processos/:id/editar',
        name: 'editarProcesso',
        component: () => import('@/modules/administrativo/views/cadastros/CadastroProcessoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },

    // Detalhe de Processo Administrativo
    {
        path: '/administrativo/processos/:id/detalhe',
        name: 'detalheProcesso',
        component: () => import('@/modules/administrativo/views/detalhes/ProcessoViews/DetalheProcessoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },

    // Lista de Busca Geral de Processos
    {
        path: '/administrativo/processos/busca-geral',
        name: 'buscarProcessos',
        component: () => import('@/modules/administrativo/views/listas/ListaBuscarProcessosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },
    // Lista de Documentos
    {
        path: '/administrativo/documentos',
        name: 'listaDocumentos',
        component: () => import('@/modules/administrativo/views/listas/ListaDocumentosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
    },
    // Detalhe de Documento
    {
        path: '/administrativo/documentos/:id/detalhe',
        name: 'detalheDocumento',
        component: () => import('@/modules/administrativo/views/detalhes/DocumentoAdministrativoViews/DetalheDocumentoAdministrativoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions('FUNCIONARIO')]},
        props: true,
    },

    // Detalhe da Fundação
    {
        path: '/administrativo/fundacao',
        name: 'detalheFundacao',
        component: () => import('@/modules/administrativo/views/detalhes/DetalheFundacaoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...composePermissions()]},
        children: [
            {
                path: 'configuracoes',
                name: 'detalheFundacaoConfiguracoes',
                component: () => import('@/modules/administrativo/views/detalhes/AbasDetalhesFundacao/ConfiguracoesTab.vue'),
                redirect: { name: 'detalheFundacaoConfiguracoesGeral' },
                meta: { requiresAuth: true, allowedRoles: [...composePermissions()]},
                children: [
                    {
                        path: 'geral',
                        name: 'detalheFundacaoConfiguracoesGeral',
                        component: () => import('@/modules/administrativo/views/detalhes/AbasDetalhesFundacao/Configuracoes/GeralTab.vue'),
                        meta: { requiresAuth: true, allowedRoles: [...composePermissions()]},
                    },
                    {
                        path: 'papeis',
                        name: 'detalheFundacaoConfiguracoesPapeis',
                        component: () => import('@/modules/administrativo/views/detalhes/AbasDetalhesFundacao/Configuracoes/PapeisAdministrativosTab.vue'),
                        meta: { requiresAuth: true, allowedRoles: [...composePermissions()]},
                    },
                ],
            },
        ],
    }
];